"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3017],{

/***/ 639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ CloseButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/class-variance-authority/dist/index.mjs + 1 modules
var dist = __webpack_require__(45139);
// EXTERNAL MODULE: ./src/components/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(7943);
// EXTERNAL MODULE: ./src/utils/cn.ts + 1 modules
var cn = __webpack_require__(72802);
;// CONCATENATED MODULE: ./src/components/atoms/CloseButton/CloseButton.tsx




var closeButtonVariants = (0,dist/* cva */.j)("inline-flex items-center bg-transparent outline-none rounded-lg text-sm", {
    variants: {
        variant: {
            default: "dark:text-white text-black hover:text-gray-900 hover:ease-in hover:duration-150 hover:bg-gray-200 p-1.5"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var CloseButton = function(param) {
    var variant = param.variant, className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (0,cn.cn)(closeButtonVariants({
            variant: variant,
            className: className
        })),
        onClick: onClick,
        children: CloseIcon/* closeIcon */.U
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/CloseButton/index.ts



/***/ }),

/***/ 62174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72802);
/* harmony import */ var _utils_ratePlayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14001);



var LivescorePlayerStats = function(param) {
    var position = param.position, stats = param.stats, rating = param.rating, className = param.className;
    var ratingValue = rating !== null && rating !== void 0 ? rating : (0,_utils_ratePlayer__WEBPACK_IMPORTED_MODULE_1__/* .calculatePlayerRating */ .o)(position, stats);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_2__.cn)("!text-white px-[2.5px] py-[1.25px] font-bold text-[8.75px] rounded-[2.5px]", ratingValue >= 7.8 ? "bg-[#1C4DFF]" : ratingValue >= 7 ? "bg-[#06C000]" : ratingValue >= 6 ? "bg-[#FFA600]" : "bg-[#FF0004]", className),
        children: ratingValue.toFixed(1)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LivescorePlayerStats);


/***/ }),

/***/ 34688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export formatDateToDDMM */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_cn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72802);
/* harmony import */ var _components_atoms_LivescorePlayerStats_LivescorePlayerStats__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62174);
/* harmony import */ var _components_atoms_LivescoreEntityLink_LivescoreEntityLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61638);
/* harmony import */ var _components_icons_ArrowRightCorner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50680);






var formatDateToDDMM = function(isoString) {
    if (!isoString) {
        return "";
    }
    var date = new Date(isoString);
    if (isNaN(date.getTime())) {
        return "";
    }
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var formattedDay = String(day).padStart(2, "0");
    var formattedMonth = String(month).padStart(2, "0");
    return "".concat(formattedDay, "/").concat(formattedMonth);
};
var PlayerAchievment = function(param) {
    var label = param.label, value = param.value, gameplay = param.gameplay;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-2 flex items-center py-[1.33px] dark:bg-black-500 bg-white border dark:border-border-400 border-gray-200 rounded-md relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_5__.cn)("font-semibold text-[10.64px]", gameplay && "font-gameplay"),
                children: label
            }),
            value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "z-20 absolute -top-1 -right-1 dark:bg-white bg-black rounded-full dark:text-black-500 text-white w-2.5 h-2.5 flex items-center justify-center font-bold text-[7px]",
                children: value
            }) : null
        ]
    });
};
var LivescoreMatchCard = function(param) {
    var match = param.match, playerPosition = param.playerPosition, player = param.player, mainCompetitorId = param.mainCompetitorId, _showWinnerStatus = param.showWinnerStatus, showWinnerStatus = _showWinnerStatus === void 0 ? true : _showWinnerStatus, _isAhref = param.isAhref, isAhref = _isAhref === void 0 ? false : _isAhref;
    var ref, ref1;
    var ref2;
    var mainCompetitorGoals = (ref2 = (ref = match.competitors.find(function(param) {
        var main = param.main, id = param.id;
        return main === true || id === mainCompetitorId;
    })) === null || ref === void 0 ? void 0 : ref.goals) !== null && ref2 !== void 0 ? ref2 : undefined;
    var ref3;
    var diffCompetitorGoals = (ref3 = (ref1 = match.competitors.find(function(param) {
        var main = param.main, id = param.id;
        return main === false && mainCompetitorId === undefined || id !== mainCompetitorId && main === undefined;
    })) === null || ref1 === void 0 ? void 0 : ref1.goals) !== null && ref3 !== void 0 ? ref3 : undefined;
    var doesWon = mainCompetitorGoals !== undefined && diffCompetitorGoals !== undefined ? mainCompetitorGoals > diffCompetitorGoals : undefined;
    var doesDraw = mainCompetitorGoals !== undefined && diffCompetitorGoals !== undefined ? mainCompetitorGoals === diffCompetitorGoals : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_LivescoreEntityLink_LivescoreEntityLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: "/livescore/match/".concat(match.id.split(":")[2]),
        className: "flex w-full items-center justify-between px-4 py-2 sm:gap-4 gap-3 dark:bg-black-400 bg-white_theme-50 rounded-lg text-black dark:text-white",
        isAhref: isAhref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-bold sm:text-[9px] text-[7px] text-gray-400",
                children: formatDateToDDMM(match.date)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sm:space-y-0 space-y-1 w-full",
                        children: match.competitors.map(function(param) {
                            var name = param.name, logo_url = param.logo_url, abbreviation = param.abbreviation, main = param.main, id = param.id, aggregate_winner = param.aggregate_winner, red_cards = param.red_cards;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2 w-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative sm:h-4 sm:w-4 w-3 h-3",
                                        children: logo_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: logo_url,
                                            alt: name,
                                            layout: "fill",
                                            objectFit: "contain"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "sm:h-4 sm:w-4 w-3 h-3 rounded-full bg-primary-600 sm:text-[6px] text-[4px] flex items-center justify-center",
                                            children: abbreviation
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_5__.cn)("sm:text-[13px] text-[10px] w-fit line-clamp-1 overflow-ellipsis", doesWon ? (main || id === mainCompetitorId) && "font-bold" : (!main && mainCompetitorId === undefined || id !== mainCompetitorId) && "font-semibold"),
                                        children: name
                                    }),
                                    red_cards ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-white font-bold text-[9px] h-[14px] w-[10px] rounded-[3px] bg-[#FF0004] flex items-center justify-center",
                                        children: red_cards
                                    }) : null,
                                    aggregate_winner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "w-min inline-block scale-50 sm:scale-[85%]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_ArrowRightCorner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            color: "#31C46C",
                                            width: 16
                                        })
                                    }) : null
                                ]
                            });
                        })
                    }),
                    player && match.player_statistics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center w-full justify-end pr-6",
                        children: [
                            match.player_statistics.minutes_played ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlayerAchievment, {
                                label: "".concat(match.player_statistics.minutes_played, "’")
                            }) : null,
                            match.player_statistics.assists ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlayerAchievment, {
                                label: "A",
                                gameplay: true,
                                value: match.player_statistics.assists.toString()
                            }) : null,
                            match.player_statistics.goals_scored ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlayerAchievment, {
                                label: "G",
                                gameplay: true,
                                value: match.player_statistics.goals_scored.toString()
                            }) : null,
                            playerPosition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_LivescorePlayerStats_LivescorePlayerStats__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                stats: match.player_statistics,
                                position: playerPosition,
                                className: "ml-2"
                            }) : null
                        ]
                    }),
                    player && !match.player_statistics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full flex items-center justify-end pr-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "dark:bg-black-400 bg-white border dark:border-border-400 border-gray-200 text-[10.64px] px-[5.32px] py-[2.66px] rounded-md",
                            children: "poza składem"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col items-center sm:gap-0 gap-1",
                        children: match.competitors.map(function(param) {
                            var goals = param.goals;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "sm:text-[11px] text-[8px] font-gameplay",
                                children: goals
                            });
                        })
                    })
                ]
            }),
            showWinnerStatus && doesWon !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_utils_cn__WEBPACK_IMPORTED_MODULE_5__.cn)("!text-white sm:w-5 sm:h-5 sm:min-w-5 min-w-[15px] w-[15px] h-[15px] rounded-sm flex items-center justify-center font-bold sm:text-[10.64px] text-[8px]", doesWon ? "bg-[#06C000]" : "bg-[#FF0004]", doesDraw && "bg-[#FFA600]"),
                children: doesWon ? "Z" : doesDraw ? "R" : "P"
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LivescoreMatchCard);


/***/ }),

/***/ 58180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ HeadlessModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/class-variance-authority/dist/index.mjs + 1 modules
var dist = __webpack_require__(45139);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(44080);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 16 modules
var dialog = __webpack_require__(80100);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(34601);
// EXTERNAL MODULE: ./src/components/atoms/CloseButton/index.ts + 1 modules
var CloseButton = __webpack_require__(639);
// EXTERNAL MODULE: ./src/components/atoms/Wrapper/index.ts + 1 modules
var Wrapper = __webpack_require__(89935);
;// CONCATENATED MODULE: ./src/components/templates/HeadlessModal/HeadlessModal.tsx








var modalVariants = (0,dist/* cva */.j)("", {
    variants: {
        variant: {
            default: "dark:text-white relative text-black border dark:border-gray-800 border-gray-250 rounded-lg overflow-y-auto dark:bg-black bg-white_theme-50 p-4 m-4",
            authModal: "dark:text-white text-black sm:border dark:sm:border-gray-800 border-gray-250 sm:rounded-lg h-full sm:max-h-[90vh] px-2 sm:px-4 pt-6 pb-6 overflow-y-auto dark:bg-black bg-white_theme-50"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var HeadlessModal = function(param) {
    var children = param.children, isOpen = param.isOpen, variant = param.variant, _title = param.title, title = _title === void 0 ? "" : _title, className = param.className, containerClassName = param.containerClassName, _isLogo = param.isLogo, isLogo = _isLogo === void 0 ? true : _isLogo, _isArrowLeft = param.isArrowLeft, isArrowLeft = _isArrowLeft === void 0 ? false : _isArrowLeft, closeModal = param.closeModal, onArrowLeftClick = param.onArrowLeftClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
        appear: true,
        show: isOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-50",
            onClose: closeModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-75"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("overflow-y-auto fixed inset-0 w-screen", containerClassName),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("flex items-center justify-center", variant === "default" ? "!h-auto !min-h-screen" : "!h-full sm:!h-auto sm:!min-h-screen"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            className: (0,clsx_m/* default */.Z)("w-full h-full sm:my-auto", className),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: modalVariants({
                                    variant: variant
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Title */.V.Title, {
                                        className: "flex justify-between items-center pb-5 pl-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* Wrapper */.i, {
                                                row: true,
                                                children: [
                                                    isArrowLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: onArrowLeftClick,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* default */.Z, {
                                                            className: "hover:opacity-80 dark:text-white text-black stroke-2 mr-3",
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    }),
                                                    !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "text-base font-bold dark:text-white text-black sm:text-xl",
                                                        children: title
                                                    }),
                                                    !title && isLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/icons/fangol-logo.svg",
                                                        alt: "Fangol logo",
                                                        width: 91,
                                                        height: 28,
                                                        priority: true,
                                                        className: "dark:invert-0 invert"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                                                variant: "default",
                                                onClick: closeModal
                                            })
                                        ]
                                    }),
                                    children
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/templates/HeadlessModal/index.ts



/***/ }),

/***/ 14001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ calculatePlayerRating; }
/* harmony export */ });
var calculatePlayerRating = function(position, stats) {
    if ((stats === null || stats === void 0 ? void 0 : stats.minutes_played) && (stats === null || stats === void 0 ? void 0 : stats.minutes_played) < 15) {
        return 6.0;
    }
    var per90Factor = (stats === null || stats === void 0 ? void 0 : stats.minutes_played) && (stats === null || stats === void 0 ? void 0 : stats.minutes_played) > 0 ? 90 / (stats === null || stats === void 0 ? void 0 : stats.minutes_played) : 1;
    var score = 6.5;
    var ref;
    score -= ((ref = stats === null || stats === void 0 ? void 0 : stats.own_goals) !== null && ref !== void 0 ? ref : 0) * 2.0;
    var ref1;
    score -= ((ref1 = stats === null || stats === void 0 ? void 0 : stats.yellow_cards) !== null && ref1 !== void 0 ? ref1 : 0) * 0.3;
    var ref2;
    score += ((ref2 = stats === null || stats === void 0 ? void 0 : stats.goals_scored) !== null && ref2 !== void 0 ? ref2 : 0) * per90Factor * 1.2;
    var ref3;
    score += ((ref3 = stats === null || stats === void 0 ? void 0 : stats.assists) !== null && ref3 !== void 0 ? ref3 : 0) * per90Factor * 0.8;
    var ref4;
    score -= ((ref4 = stats === null || stats === void 0 ? void 0 : stats.fouls_committed) !== null && ref4 !== void 0 ? ref4 : 0) * per90Factor * 0.05;
    var ref5;
    score += ((ref5 = stats === null || stats === void 0 ? void 0 : stats.was_fouled) !== null && ref5 !== void 0 ? ref5 : 0) * per90Factor * 0.05;
    var ref6;
    score -= ((ref6 = stats === null || stats === void 0 ? void 0 : stats.loss_of_possession) !== null && ref6 !== void 0 ? ref6 : 0) * per90Factor * 0.05;
    var ref7, ref8, ref9;
    var passAccuracy = ((ref7 = stats === null || stats === void 0 ? void 0 : stats.passes_total) !== null && ref7 !== void 0 ? ref7 : 0) > 0 ? ((ref8 = stats === null || stats === void 0 ? void 0 : stats.passes_successful) !== null && ref8 !== void 0 ? ref8 : 0) / ((ref9 = stats === null || stats === void 0 ? void 0 : stats.passes_total) !== null && ref9 !== void 0 ? ref9 : 0) : 0;
    if (passAccuracy > 0) {
        score += (passAccuracy - 0.75) * 1.5;
    }
    switch(position.toLowerCase()){
        case "goalkeeper":
            var ref10;
            score += ((ref10 = stats === null || stats === void 0 ? void 0 : stats.shots_faced_saved) !== null && ref10 !== void 0 ? ref10 : 0) * 0.2;
            var ref11;
            score += ((ref11 = stats === null || stats === void 0 ? void 0 : stats.diving_saves) !== null && ref11 !== void 0 ? ref11 : 0) * 0.25;
            var ref12;
            score += ((ref12 = stats === null || stats === void 0 ? void 0 : stats.penalties_saved) !== null && ref12 !== void 0 ? ref12 : 0) * 1.0;
            var ref13;
            score -= ((ref13 = stats === null || stats === void 0 ? void 0 : stats.goals_conceded) !== null && ref13 !== void 0 ? ref13 : 0) * 0.4;
            var ref14, ref15;
            if (((ref14 = stats === null || stats === void 0 ? void 0 : stats.goals_conceded) !== null && ref14 !== void 0 ? ref14 : 0) === 0 && ((ref15 = stats === null || stats === void 0 ? void 0 : stats.minutes_played) !== null && ref15 !== void 0 ? ref15 : 0) > 60) score += 0.8;
            break;
        case "defender":
            var ref16;
            score -= ((ref16 = stats === null || stats === void 0 ? void 0 : stats.goals_conceded) !== null && ref16 !== void 0 ? ref16 : 0) * 0.1;
            var ref17;
            score += ((ref17 = stats === null || stats === void 0 ? void 0 : stats.tackles_successful) !== null && ref17 !== void 0 ? ref17 : 0) * per90Factor * 0.25;
            var ref18;
            score += ((ref18 = stats === null || stats === void 0 ? void 0 : stats.interceptions) !== null && ref18 !== void 0 ? ref18 : 0) * per90Factor * 0.2;
            var ref19;
            score += ((ref19 = stats === null || stats === void 0 ? void 0 : stats.clearances) !== null && ref19 !== void 0 ? ref19 : 0) * per90Factor * 0.1;
            var ref20;
            score += ((ref20 = stats === null || stats === void 0 ? void 0 : stats.defensive_blocks) !== null && ref20 !== void 0 ? ref20 : 0) * per90Factor * 0.15;
            var ref21, ref22;
            if (((ref21 = stats === null || stats === void 0 ? void 0 : stats.goals_conceded) !== null && ref21 !== void 0 ? ref21 : 0) === 0 && ((ref22 = stats === null || stats === void 0 ? void 0 : stats.minutes_played) !== null && ref22 !== void 0 ? ref22 : 0) > 60) {
                score += 0.5;
            }
            break;
        case "midfielder":
            var ref23;
            score += ((ref23 = stats === null || stats === void 0 ? void 0 : stats.chances_created) !== null && ref23 !== void 0 ? ref23 : 0) * per90Factor * 0.3;
            var ref24;
            score += ((ref24 = stats === null || stats === void 0 ? void 0 : stats.dribbles_completed) !== null && ref24 !== void 0 ? ref24 : 0) * per90Factor * 0.2;
            var ref25;
            score += ((ref25 = stats === null || stats === void 0 ? void 0 : stats.tackles_successful) !== null && ref25 !== void 0 ? ref25 : 0) * per90Factor * 0.1;
            var ref26;
            score += ((ref26 = stats === null || stats === void 0 ? void 0 : stats.interceptions) !== null && ref26 !== void 0 ? ref26 : 0) * per90Factor * 0.1;
            var ref27, ref28, ref29;
            var longPassAccuracy = ((ref27 = stats === null || stats === void 0 ? void 0 : stats.long_passes_total) !== null && ref27 !== void 0 ? ref27 : 0) > 0 ? ((ref28 = stats === null || stats === void 0 ? void 0 : stats.long_passes_successful) !== null && ref28 !== void 0 ? ref28 : 0) / ((ref29 = stats === null || stats === void 0 ? void 0 : stats.long_passes_total) !== null && ref29 !== void 0 ? ref29 : 0) : 0;
            score += longPassAccuracy * 0.3;
            break;
        case "forward":
            var ref30;
            score += ((ref30 = stats === null || stats === void 0 ? void 0 : stats.shots_on_target) !== null && ref30 !== void 0 ? ref30 : 0) * per90Factor * 0.2;
            var ref31;
            score -= ((ref31 = stats === null || stats === void 0 ? void 0 : stats.shots_off_target) !== null && ref31 !== void 0 ? ref31 : 0) * per90Factor * 0.1;
            var ref32;
            score += ((ref32 = stats === null || stats === void 0 ? void 0 : stats.chances_created) !== null && ref32 !== void 0 ? ref32 : 0) * per90Factor * 0.4;
            var ref33;
            score += ((ref33 = stats === null || stats === void 0 ? void 0 : stats.dribbles_completed) !== null && ref33 !== void 0 ? ref33 : 0) * per90Factor * 0.3;
            var ref34;
            score -= ((ref34 = stats === null || stats === void 0 ? void 0 : stats.offsides) !== null && ref34 !== void 0 ? ref34 : 0) * per90Factor * 0.1;
            break;
        default:
            var ref35;
            score += ((ref35 = stats === null || stats === void 0 ? void 0 : stats.chances_created) !== null && ref35 !== void 0 ? ref35 : 0) * per90Factor * 0.2;
            var ref36;
            score += ((ref36 = stats === null || stats === void 0 ? void 0 : stats.dribbles_completed) !== null && ref36 !== void 0 ? ref36 : 0) * per90Factor * 0.15;
            break;
    }
    var finalRating = score;
    finalRating = Math.max(3.0, finalRating);
    finalRating = Math.min(10.0, finalRating);
    var ref37, ref38;
    if (((ref37 = stats === null || stats === void 0 ? void 0 : stats.red_cards) !== null && ref37 !== void 0 ? ref37 : 0) > 0 || ((ref38 = stats === null || stats === void 0 ? void 0 : stats.yellow_red_cards) !== null && ref38 !== void 0 ? ref38 : 0) > 0) {
        finalRating = Math.min(finalRating, 5.0);
    }
    return parseFloat(finalRating.toFixed(1));
};


/***/ })

}]);